import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Linkedin, Twitter } from "lucide-react";
const services = ["Tax Planning", "Business Tax Consulting", "IRS Audit Support", "Financial Strategy"];
const companyLinks = [{
  label: "About Us",
  href: "#"
}, {
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Terms of Service",
  href: "#"
}];
const socialLinks = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}];
export default function CorporateFootnote() {
  const currentYear = new Date().getFullYear();
  return <section id="corporate-footnote" className="bg-background pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <Separator className="mb-16" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-12 lg:gap-8">
          {}
          <div className="flex items-center gap-8">
            <Link to="/HomePage#" className="flex items-center gap-3">
              <img src="https://dashing-rooster-1.10web.cloud/wp-content/uploads/2026/03/compass-icon-transparent.dim_200x200.png" alt="FinTax Logo" className="h-7 w-auto object-contain" />
              <h2 className="text-[20px] font-serif font-bold text-[#040C13] whitespace-nowrap">
                Northland Financial Solutions
              </h2>
            </Link>
            
          </div>

          {}
          <div>
            <h3 className="text-[#040C13] font-semibold mb-6 text-sm tracking-wide uppercase">
              Services
            </h3>
            <ul className="space-y-4">
              {services.map((service, i) => <li key={service} data-index={i}>
                  <Link to="#" className="text-[#040C13] hover:text-primary text-sm transition-colors duration-200">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-[#040C13] font-semibold mb-6 text-sm tracking-wide uppercase">
              Company
            </h3>
            <ul className="space-y-4">
              {companyLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-[#040C13] hover:text-primary text-sm transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          
        </div>

        <Separator className="my-12" />

        {}
        <div className="flex flex-col justify-between gap-4 !items-center md:flex-row text-center">
          <p className="text-[#040C13] text-xs">© 2026 Northland Financial Solutions, LLC. All rights reserved.</p>
          <div className="flex items-center gap-6">
            
            
          </div>
        </div>
      </div>
    </section>;
}